import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { CustomerImpersonationWarning } from '../../../web/components/CustomerImpersonationWarning';
import { Header } from '../../components/Header';
import { isStatusBannerShowing } from '../../components/StatusBanner/isStatusBannerShowing';
import { useTysonMode } from '../../contexts/tysonMode';
import { ViewportContext } from '../../hooks/useViewport';
import { BodyContainer } from './components/BodyContainer';
import { styleSheet } from './styles';

export type HeaderSize = 'short' | 'tall';

const MainContainerBase = ({
	children,
	bodyContainerStyles,
}: {
	children?: React.ReactNode;
	bodyContainerStyles?: StyleDeclarationValue[];
}) => {
	const location = useLocation();
	const userSession = useUserSession();
	const { isActive: isTysonModeActive } = useTysonMode();

	const [headerHeight, setHeaderHeight] = useState<HeaderSize>('tall');
	const { isBelowSmall } = useContext(ViewportContext);
	const isStatusBannerHidden = !isStatusBannerShowing(location?.pathname, isBelowSmall);

	useEffect(() => {
		setHeaderHeight(
			!!location?.pathname && !location?.pathname.includes('settings') && !location?.pathname.includes('reporting')
				? 'tall'
				: 'short'
		);
	}, [location?.pathname]);

	return (
		<div className={css(styleSheet.container, isTysonModeActive && styleSheet.tysonBackground)}>
			<Header />
			<BodyContainer headerHeight={headerHeight} styles={bodyContainerStyles}>
				<CustomerImpersonationWarning
					styles={
						isStatusBannerHidden
							? [styleSheet.impersonating, styleSheet.impersonatingInFlow]
							: [styleSheet.impersonating]
					}
					userSession={userSession}
				/>
				{children}
			</BodyContainer>
		</div>
	);
};

export const MainContainer = observer(MainContainerBase);
